import React from "react";
import mainbanner from "../../pages/assets/probimainbanner3.jpg";

const Hero3 = () => {
  return (
    <div
      className="h-screen w-full bg-cover bg-center flex items-center justify-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${mainbanner})`,
      }}
    >
      {/* Content */}
      <div className="text-white px-4 text-center max-w-3xl font-lato">
        <h1 className="text-4xl md:text-6xl font-bold mb-4">
          <span className=" glass">Unlock </span>
          the Power of Digital Wealth{" "}
        </h1>
        <p className="text-lg md:text-xl mb-6">
          Dive into the world of cryptocurrency with confidence. Our platform
          empowers you to invest, trade, and succeed in the ever-evolving
          digital economy.
        </p>
        <button
          className="px-8 py-4 text-lg font-semibold text-white bg-secondary-500 rounded-lg shadow-lg hover:bg-secondary-600 transition"
          onClick={() => (window.location.href = "/login")}
        >
          Login
        </button>
      </div>
    </div>
  );
};

export default Hero3;
